import Icon from '@/components/ui/AppIcon';

interface Stat {
  label: string;
  value: string;
  icon: string;
  color: string;
}

interface RegionalStatsProps {
  stats: Stat[];
}

export default function RegionalStats({ stats }: RegionalStatsProps) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {stats.map((stat, index) => (
        <div
          key={index}
          className="bg-card rounded-xl p-6 shadow-warm hover:shadow-warm-lg transition-all duration-300 hover:-translate-y-1"
        >
          <div className={`w-12 h-12 rounded-full ${stat.color} flex items-center justify-center mb-4`}>
            <Icon name={stat.icon as any} size={24} className="text-white" />
          </div>
          <p className="text-3xl font-heading font-bold text-text-primary mb-1">
            {stat.value}
          </p>
          <p className="text-sm text-muted-foreground font-medium">{stat.label}</p>
        </div>
      ))}
    </div>
  );
}